import React from 'react';

const BoltBadge: React.FC = () => {
  return (
    <a
      href="https://bolt.new/"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block transition-transform hover:scale-105"
    >
      <img 
        src="/white_circle_360x360.png" 
        alt="Powered by Bolt.new" 
        className="w-24 h-24 sm:w-28 sm:h-28 object-contain"
      />
    </a>
  );
};

export default BoltBadge;